import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  deleteSingleDeliveryAddressApi,
  getDeliveryAddressesApi,
  getSingleDeliveryAddressApi,
  postSingleDeliveryAddressApi,
  setDefaultDeliveryAddressApi,
  updateSingleDeliveryAddressApi,
} from "../../api/user-processing-api/AddressApi";

// Async thunks for API calls
export const getDeliveryAddresses = createAsyncThunk(
  "address/getDeliveryAddresses",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getDeliveryAddressesApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const getSingleDeliveryAddress = createAsyncThunk(
  "address/getSingleDeliveryAddress",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getSingleDeliveryAddressApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const postSingleDeliveryAddress = createAsyncThunk(
  "address/postSingleDeliveryAddress",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await postSingleDeliveryAddressApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const updateSingleDeliveryAddress = createAsyncThunk(
  "address/updateSingleDeliveryAddress",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateSingleDeliveryAddressApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const deleteSingleDeliveryAddress = createAsyncThunk(
  "address/deleteSingleDeliveryAddress",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await deleteSingleDeliveryAddressApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

export const setDefaultDeliveryAddress = createAsyncThunk(
  "address/setDefaultDeliveryAddress",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await setDefaultDeliveryAddressApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message,
      });
    }
  },
);

// Initial state

const initialState = {
  loading: false,
  posting: false,
  defaulting: false,
  deleting: false,
  addresses: [],
  singleAddress: {},
  selectedAdress: {},
};

// Slice definition
const AddressSlice = createSlice({
  name: "address",
  initialState,
  reducers: {
    setAdress: (state, action) => {
      state.selectedAdress = action.payload;
    },
    setSingleAddress: (state, action) => {
      state.singleAddress = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDeliveryAddresses.pending, (state) => {
        state.loading = true;
        state.addresses = [];
      })
      .addCase(getDeliveryAddresses.fulfilled, (state, action) => {
        state.loading = false;
        state.addresses = action.payload.response;
      })
      .addCase(getDeliveryAddresses.rejected, (state) => {
        state.loading = false;
        state.addresses = [];
      });

    builder
      .addCase(getSingleDeliveryAddress.pending, (state) => {
        state.posting = true;
        state.singleAddress = {};
      })
      .addCase(getSingleDeliveryAddress.fulfilled, (state, action) => {
        state.posting = false;
        state.singleAddress = action.payload.response;
      })
      .addCase(getSingleDeliveryAddress.rejected, (state) => {
        state.posting = false;
        state.singleAddress = {};
      });

    builder
      .addCase(postSingleDeliveryAddress.pending, (state) => {
        state.posting = true;
        state.singleAddress = {};
      })
      .addCase(postSingleDeliveryAddress.fulfilled, (state, action) => {
        state.posting = false;
        state.singleAddress = action.payload.response;
      })
      .addCase(postSingleDeliveryAddress.rejected, (state) => {
        state.posting = false;
        state.singleAddress = {};
      });

    builder
      .addCase(updateSingleDeliveryAddress.pending, (state) => {
        state.posting = true;
        state.singleAddress = {};
      })
      .addCase(updateSingleDeliveryAddress.fulfilled, (state, action) => {
        state.posting = false;
        state.singleAddress = action.payload.response;
      })
      .addCase(updateSingleDeliveryAddress.rejected, (state) => {
        state.posting = false;
        state.singleAddress = {};
      });

    builder
      .addCase(deleteSingleDeliveryAddress.pending, (state) => {
        state.deleting = true;
        state.singleAddress = {};
      })
      .addCase(deleteSingleDeliveryAddress.fulfilled, (state, action) => {
        state.deleting = false;
        state.singleAddress = action.payload.response;
      })
      .addCase(deleteSingleDeliveryAddress.rejected, (state) => {
        state.deleting = false;
        state.singleAddress = {};
      });

    builder
      .addCase(setDefaultDeliveryAddress.pending, (state) => {
        state.defaulting = true;
        state.singleAddress = {};
      })
      .addCase(setDefaultDeliveryAddress.fulfilled, (state, action) => {
        state.defaulting = false;
        state.singleAddress = action.payload.response;
      })
      .addCase(setDefaultDeliveryAddress.rejected, (state) => {
        state.defaulting = false;
        state.singleAddress = {};
      });
  },
});

export const { setAdress, setSingleAddress } = AddressSlice.actions;
export default AddressSlice.reducer;
